<template>
  <div class="cartao-observacao medio">
    <div
      style="line-break: anywhere; overflow-y: auto; width: 92%"
      class="scroll-design"
    >
      {{ observacao }}
    </div>
    <div class="icone-mais ml-auto">
      <unicom-menu-grupo
        :estiloConjunto="{ top: '14px', right: '0%' }"
        v-model="mostrarMenu"
      >
        <div
          slot="content"
          @click="mostrarMenu = !mostrarMenu"
          v-if="podeAparecerIconeAcao"
        >
          <unicom-icone nome="more-horizontal" :tamanho="20" />
        </div>
        <div slot="body">
          <unicom-linha
            @click="clickAcao(index)"
            :espacamento="false"
            class="lista-icones"
            v-for="(l, index) in listaAcoes"
            :key="index"
          >
            <unicom-coluna sm="auto" class="lista-icone">
              <unicom-icone :nome="l.icone" :tamanho="16" />
            </unicom-coluna>
            <unicom-coluna sm="auto">
              <div>
                {{ l.texto }}
              </div>
            </unicom-coluna>
          </unicom-linha>
        </div>
      </unicom-menu-grupo>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    observacao: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      listaAcoes: [
        {
          icone: "edit",
          texto: "Editar"
        },
        {
          icone: "trash-2",
          texto: "Excluir"
        }
      ],
      mostrarMenu: false
    };
  },
  methods: {
    clickAcao(index) {
      this.mostrarMenu = false;

      this.$nextTick(() => {
        switch (index) {
          case 0:
            this.$emit("editar", true);
            break;
          case 1:
            this.$emit("excluir");
            break;
        }
      });
    }
  },
  mounted() {
    this.$emit("altura", this.$el.scrollHeight);
  },

  computed: {
    podeAparecerIconeAcao() {
      return this.$route.name === "DetalhesUnimed";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./LinhaObservacao";
</style>
